export default "__VITE_ASSET__B5bw0yCS__"